export default {
  es: {
    extensionErrorMessage: 'La extensión del archivo no es soportada',
    fullScreen: 'Pantalla completa'
  },
  en: {
    extensionErrorMessage: 'The file extension is not supported',
    fullScreen: 'Full screen'
  }
};
